import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogProps } from '@leadsnavi/ui-kit';
import { PropsWithChildren, useState } from 'react';

interface GoogleStreetViewDialogProps extends Pick<DialogProps, 'open' | 'onOpenChange'>, PropsWithChildren {
  title?: string;
  location: string;
  heading?: number;
  pitch?: number;
  fov?: number;
  language?: string;
  className?: string;
}

export const GoogleStreetViewDialog = ({
  children,
  open,
  onOpenChange,
  title = 'Street View',
  location,
  heading = 210,
  pitch = 10,
  fov = 80,
  language = 'zh-CN',
  className = '',
}: GoogleStreetViewDialogProps) => {
  const googleMapsApiKey = 'AIzaSyDYxpDFEiB3MkEFCl2diovRNQq8OSqenWk';
  const url = `https://www.google.com/maps/embed/v1/streetview?key=${googleMapsApiKey}&location=${location}&heading=${heading}&pitch=${pitch}&fov=${fov}&language=${language}`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{children}</DialogTrigger>

      <DialogContent className={`max-w-4xl  ${className}`}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="mt-4 h-[60vh]">
          {open && (
            <iframe
              title="Google Street View"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              src={url}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

// 导出一个简单的使用示例
export const GoogleStreetViewDialogExample = () => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <GoogleStreetViewDialog
        open={open}
        onOpenChange={setOpen}
        location="51.631272599999996,-0.7920345999999999"
        title="Street View Example"
      >
        <button className="px-4 py-2 bg-blue-500 text-white rounded">View Street View</button>
      </GoogleStreetViewDialog>
    </div>
  );
};
